if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.mainAtcButton = this.productSection.querySelector('button[name="add"]');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      // On mobile, the panel is held hidden for 4 s on first load.
      // The observer records what it *wants* to do during that window,
      // then the timeout applies the correct state and hands control back.
      let isReady = !theme.mediaMatches.md ? false : true;
      let shouldShow = false;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.mainAtcButton && !theme.mediaMatches.md) {
            if (isReady) {
              this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
            } else {
              // Main ATC button not visible → panel should show after delay
              shouldShow = !entry.isIntersecting;
            }
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.mainAtcButton) observer.observe(this.mainAtcButton);
      if (this.productInfo) observer.observe(this.productInfo);

      // On mobile: wait 4 s, then slide up if the main ATC button isn't visible
      if (!theme.mediaMatches.md) {
        setTimeout(() => {
          isReady = true;
          if (shouldShow) {
            this.classList.remove('sticky-atc-panel--out');
          }
        }, 4000);
      }

      // Wire sticky ATC button to click the main ATC button, delegating all
      // AJAX, loading states, and cart drawer behaviour to product-form.js
      const stickyBtn = this.querySelector('.js-sticky-atc-btn');
      if (stickyBtn && this.mainAtcButton) {
        stickyBtn.addEventListener('click', () => {
          this.mainAtcButton.click();
        });

        // Mirror is-loading / is-success / aria-disabled from the main ATC button
        // so the sticky button shows the same spinner and tick animation
        const stateObserver = new MutationObserver(() => {
          ['is-loading', 'is-success'].forEach((cls) => {
            stickyBtn.classList.toggle(cls, this.mainAtcButton.classList.contains(cls));
          });
          if (this.mainAtcButton.getAttribute('aria-disabled') === 'true') {
            stickyBtn.setAttribute('aria-disabled', 'true');
          } else {
            stickyBtn.removeAttribute('aria-disabled');
          }
        });
        stateObserver.observe(this.mainAtcButton, {
          attributes: true,
          attributeFilter: ['class', 'aria-disabled']
        });
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
